import { render, staticRenderFns } from "./DataListjobRiskAssessments.vue?vue&type=template&id=953094dc&scoped=true&"
import script from "./DataListjobRiskAssessments.vue?vue&type=script&lang=js&"
export * from "./DataListjobRiskAssessments.vue?vue&type=script&lang=js&"
import style0 from "./DataListjobRiskAssessments.vue?vue&type=style&index=0&id=953094dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953094dc",
  null
  
)

export default component.exports